import { useRef, useState } from "react";
import { AlertDialog, AlertDialogHeader, AlertDialogOverlay, AlertDialogContent, AlertDialogBody, AlertDialogFooter, Button } from "@chakra-ui/react";
import { DangerIcon } from "lib/icons/danger";
import { teamClient } from "lib/clients";
import { useBilling, useToastNotification } from "lib/hooks";

export const CancelSubscriptionAlert = ({ isOpen, onClose }) => {
  const [pending, setPending] = useState<boolean>(false);
  const { mutate } = useBilling();
  const cancelRef = useRef();
  const { errorToast } = useToastNotification();

  const removeSubscription = async () => {
    try {
      setPending(true);

      await teamClient.updateSubscription({
        cancel: true,
      });

      mutate();
      onClose();
    } catch (err) {
      errorToast({ title: 'Error', description: 'Could not cancel subscription, please try again.' })
    } finally {
      setPending(false);
    }
  }

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
    >
      <AlertDialogOverlay />
      <AlertDialogContent className="dialog__content">
        <AlertDialogHeader className="dialog-delete__header">
          <DangerIcon width="22px" height="22px"/>
          Are you sure you want to cancel?
        </AlertDialogHeader>
        <AlertDialogBody className="dialog-delete__content">
          You&apos;ll lose access to any features that require an active subscription.
        </AlertDialogBody>
        <AlertDialogFooter className="dialog-delete__footer">
          <Button variant="cancel" ref={cancelRef} onClick={onClose}>Cancel</Button>
          <Button variant="destructive" isLoading={pending} onClick={() => removeSubscription()}>Cancel My Subscription</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
};
